module.exports = __webpack_public_path__ + "img/7guang.9ff71c4d.jpg";